import RenderAppointmentWidget from "./organisms/universal-patient-search/render-appointment-widget";
import AppointmentConfigsScreen from "./pages/appointment-configs-screen";
import CurrentTreatmentScreen from "./pages/current-treatment-screen";
import HprHfrOnboarding from "./pages/hpr-hfr-onboarding";
import ManageServicesScreen from "./pages/manage-services-screen";
import ManageTreatmentPackagesScreen from "./pages/manage-treatment-packages-screen";
import PaymentDashboard from "./pages/payment-dashboard";
import QueueDashboard from "./pages/queue-dashboard";
import ReceiptCustomisation from "./pages/receipt-customisation";
import { ContainersExported, RendererParams } from "./react-app-env";

const componentRegister: Record<
  ContainersExported,
  React.FC<RendererParams>
> = {
  billingDashboard: PaymentDashboard,
  receiptCustomisation: ReceiptCustomisation,
  renderNewAppt: QueueDashboard,
  renderAppointmentWidget: RenderAppointmentWidget,
  hprHfrOnboarding: HprHfrOnboarding,
  manageTreatmentPackagesScreen: ManageTreatmentPackagesScreen,
  currentTreatmentScreen: CurrentTreatmentScreen,
  manageServicesScreen: ManageServicesScreen,
  appointmentConfigsScreen: AppointmentConfigsScreen,
};

export default componentRegister;
